import { Classes, Icon, Intent, ITreeNode, Tree } from "@blueprintjs/core";
import { ContextMenu2 } from "@blueprintjs/popover2";
import { v4 as uuid } from "uuid";
import { Instruction } from "src/models/Instruction";
import "./SetInstructionsTree.scss";

type Props = {
    instructions: Array<Instruction>;
};

export default function SetInstructionsTree({ instructions }: Props) {
    return (
        <div className="instruction-tree">
            <Tree contents={getNodes(instructions)} className={Classes.ELEVATION_0} />
        </div>
    );
}

function getNodes(instructions: Array<Instruction> | undefined): Array<ITreeNode> {
    if (!instructions) {
        return [];
    }
    return instructions.map(i => {
        const preconditions = i.precondition.map(p => ({
            id: uuid(),
            icon: <Icon icon="confirm" intent={Intent.SUCCESS} className={Classes.TREE_NODE_ICON} />,
            label: <ContextMenu2 content={<></>}>{p}</ContextMenu2>
        }));
        const dependencies = i.dependsOn.map(d => ({
            id: uuid(),
            icon: <Icon icon="th-derived" intent={Intent.PRIMARY} className={Classes.TREE_NODE_ICON} />,
            label: <ContextMenu2 content={<></>}>{instructions.find(a => a.instructionId === d)?.alias}</ContextMenu2>
        }));
        const children = preconditions.concat(dependencies);
        return {
            id: i.instructionId,
            icon: "code",
            label: <ContextMenu2 content={<></>}>{i.alias}</ContextMenu2>,
            childNodes: children.length > 0 ? children : undefined,
            isExpanded: true,
            hasCaret: false,
            isSelected: false
        };
    });
}
